import { render, staticRenderFns } from "./CategoryTab.vue?vue&type=template&id=d99b3b96&scoped=true&"
import script from "./CategoryTab.vue?vue&type=script&lang=js&"
export * from "./CategoryTab.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTab.vue?vue&type=style&index=0&id=d99b3b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99b3b96",
  null
  
)

export default component.exports